webpackJsonp([37],{

/***/ 105:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return setStore; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return getStore; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return removeStore; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(383);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);

/**
 * 存储localStorage
 */
var setStore = function setStore(name, content) {
  if (!name) return;
  if (typeof content !== 'string') {
    content = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(content);
  }
  window.localStorage.setItem(name, content);
};

/**
 * 获取localStorage
 */
var getStore = function getStore(name) {
  if (!name) return;
  return window.localStorage.getItem(name);
};

/**
 * 删除localStorage
 */
var removeStore = function removeStore(name) {
  if (!name) return;
  window.localStorage.removeItem(name);
};

/***/ }),

/***/ 194:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_router__ = __webpack_require__(743);



var Index = function Index() {
  return __webpack_require__.e/* import() */(21).then(__webpack_require__.bind(null, 815));
};
var IndexOld = function IndexOld() {
  return __webpack_require__.e/* import() */(22).then(__webpack_require__.bind(null, 814));
};
var DataAnalysis = function DataAnalysis() {
  return __webpack_require__.e/* import() */(29).then(__webpack_require__.bind(null, 812));
};
var Publish = function Publish() {
  return __webpack_require__.e/* import() */(4).then(__webpack_require__.bind(null, 817));
};
var Center = function Center() {
  return __webpack_require__.e/* import() */(30).then(__webpack_require__.bind(null, 811));
};
var GgxxDetail = function GgxxDetail() {
  return __webpack_require__.e/* import() */(28).then(__webpack_require__.bind(null, 813));
};
var About = function About() {
  return __webpack_require__.e/* import() */(31).then(__webpack_require__.bind(null, 810));
};
var Insurance = function Insurance() {
  return __webpack_require__.e/* import() */(32).then(__webpack_require__.bind(null, 816));
};

var Login = function Login() {
  return __webpack_require__.e/* import() */(13).then(__webpack_require__.bind(null, 789));
};
var Register = function Register() {
  return __webpack_require__.e/* import() */(20).then(__webpack_require__.bind(null, 790));
};
var Home = function Home() {
  return __webpack_require__.e/* import() */(5).then(__webpack_require__.bind(null, 788));
};
var GoodS = function GoodS() {
  return __webpack_require__.e/* import() */(12).then(__webpack_require__.bind(null, 784));
};
var goodsActivityList = function goodsActivityList() {
  return __webpack_require__.e/* import() */(11).then(__webpack_require__.bind(null, 786));
};
var goodsActivityDetails = function goodsActivityDetails() {
  return __webpack_require__.e/* import() */(7).then(__webpack_require__.bind(null, 785));
};
var goodsDetails = function goodsDetails() {
  return __webpack_require__.e/* import() */(6).then(__webpack_require__.bind(null, 787));
};
var Cart = function Cart() {
  return __webpack_require__.e/* import() */(3).then(__webpack_require__.bind(null, 782));
};
var order = function order() {
  return __webpack_require__.e/* import() */(24).then(__webpack_require__.bind(null, 792));
};
var user = function user() {
  return __webpack_require__.e/* import() */(23).then(__webpack_require__.bind(null, 809));
};
var orderList = function orderList() {
  return __webpack_require__.e/* import() */(26).then(__webpack_require__.bind(null, 806));
};
var information = function information() {
  return __webpack_require__.e/* import() */(14).then(__webpack_require__.bind(null, 805));
};
var addressList = function addressList() {
  return __webpack_require__.e/* import() */(10).then(__webpack_require__.bind(null, 802));
};
var coupon = function coupon() {
  return __webpack_require__.e/* import() */(9).then(__webpack_require__.bind(null, 804));
};
var aihuishou = function aihuishou() {
  return __webpack_require__.e/* import() */(27).then(__webpack_require__.bind(null, 803));
};
var support = function support() {
  return __webpack_require__.e/* import() */(25).then(__webpack_require__.bind(null, 808));
};
var checkout = function checkout() {
  return __webpack_require__.e/* import() */(1).then(__webpack_require__.bind(null, 783));
};
var payment = function payment() {
  return __webpack_require__.e/* import() */(15).then(__webpack_require__.bind(null, 793));
};
var paysuccess = function paysuccess() {
  return __webpack_require__.e/* import() */(18).then(__webpack_require__.bind(null, 794));
};
var Thanks = function Thanks() {
  return __webpack_require__.e/* import() */(0).then(__webpack_require__.bind(null, 801));
};
var Search = function Search() {
  return __webpack_require__.e/* import() */(2).then(__webpack_require__.bind(null, 800));
};
var RefreshSearch = function RefreshSearch() {
  return __webpack_require__.e/* import() */(33).then(__webpack_require__.bind(null, 799));
};
var RefreshGoods = function RefreshGoods() {
  return __webpack_require__.e/* import() */(35).then(__webpack_require__.bind(null, 797));
};
var refreshgoodsActivity = function refreshgoodsActivity() {
  return __webpack_require__.e/* import() */(34).then(__webpack_require__.bind(null, 798));
};

var orderDetail = function orderDetail() {
  return __webpack_require__.e/* import() */(8).then(__webpack_require__.bind(null, 807));
};
var Alipay = function Alipay() {
  return __webpack_require__.e/* import() */(19).then(__webpack_require__.bind(null, 791));
};
var Wechat = function Wechat() {
  return __webpack_require__.e/* import() */(16).then(__webpack_require__.bind(null, 796));
};
var QQpay = function QQpay() {
  return __webpack_require__.e/* import() */(17).then(__webpack_require__.bind(null, 795));
};
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]);
/* harmony default export */ __webpack_exports__["a"] = (new __WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]({
  routes: [{
    path: '/',
    component: Index,
    name: 'index',
    redirect: '/home',
    children: [{ path: 'home', component: Home }, { path: 'goods', component: GoodS }, { path: 'goodsDetails', name: 'goodsDetails', component: goodsDetails }, { path: 'goodsActivityList', component: goodsActivityList }, { path: 'goodsActivityDetails', name: 'goodsActivityDetails', component: goodsActivityDetails }, { path: 'thanks', name: 'thanks', component: Thanks }, { path: '/refreshgoodsActivity', name: 'refreshgoodsActivity', component: refreshgoodsActivity }, { path: '/refreshgoods', name: 'refreshgoods', component: RefreshGoods }, { path: '/dataAnalysis', name: 'dataAnalysis', component: DataAnalysis }, { path: '/publish', name: 'publish', component: Publish }, { path: '/center', name: 'center', component: Center }, { path: '/ggxxDetail', name: 'ggxxDetail', component: GgxxDetail }, { path: '/about', name: 'about', component: About }, { path: '/insurance', name: 'insurance', component: Insurance }]
  }, { path: '/indexOld', name: 'indexOld', component: IndexOld }, { path: '/login', name: 'login', component: Login }, { path: '/register', name: 'register', component: Register }, { path: '/cart', name: 'cart', component: Cart }, { path: '/refreshsearch', name: 'refreshsearch', component: RefreshSearch }, {
    path: '/order',
    name: 'order',
    component: order,
    children: [{ path: 'paysuccess', name: 'paysuccess', component: paysuccess }, { path: 'payment', name: 'payment', component: payment }, { path: '/search', name: 'search', component: Search }, { path: 'alipay', name: 'alipay', component: Alipay }, { path: 'wechat', name: 'wechat', component: Wechat }, { path: 'qqpay', name: 'qqpay', component: QQpay }]
  }, {
    path: '/user',
    name: 'user',
    component: user,
    redirect: '/user/orderList',
    children: [{ path: 'orderList', name: '订单列表', component: orderList }, { path: 'orderDetail', name: '订单详情', component: orderDetail }, { path: 'information', name: '账户资料', component: information }, { path: 'addressList', name: '收货地址', component: addressList }, { path: 'coupon', name: '我的优惠', component: coupon }, { path: 'support', name: '售后服务', component: support }, { path: 'aihuishou', name: '以旧换新', component: aihuishou }]
  }, { path: '/checkout', name: 'checkout', component: checkout }, { path: '*', redirect: '/home' }]
}));

/***/ }),

/***/ 195:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(343);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__mutations__ = __webpack_require__(382);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__action__ = __webpack_require__(380);




__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_1_vuex__["c" /* default */]);

var state = {
  login: false, // 是否登录
  userInfo: null, // 用户信息
  cartList: [], // 加入购物车列表
  showMoveImg: false, // 显示飞入图片
  elLeft: 0,
  elTop: 0,
  moveImgUrl: null,
  cartPositionT: 0, // 购物车位置
  cartPositionL: 0,
  receiveInCart: false, // 是否进入购物车
  showCart: false // 是否显示购物车
};

/* harmony default export */ __webpack_exports__["a"] = (new __WEBPACK_IMPORTED_MODULE_1_vuex__["c" /* default */].Store({
  state: state,
  action: __WEBPACK_IMPORTED_MODULE_3__action__["a" /* default */],
  mutations: __WEBPACK_IMPORTED_MODULE_2__mutations__["a" /* default */]
}));

/***/ }),

/***/ 199:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return registerForWeb; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return getSmsCode; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return loginForWeb; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return loginByCodeForWeb; });
/* unused harmony export userInfoForWeb */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "u", function() { return submitUserInfoForWeb; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "v", function() { return submitGgxx; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "l", function() { return searchGgxxPage; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "m", function() { return searchGgxxRealCountBatch; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "r", function() { return ggxxDetail; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "w", function() { return searchMyGgxxList; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "t", function() { return searchMyGgxxPage; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return countMyGgxxNumber; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "y", function() { return visitorList; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return visitorAllList; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "x", function() { return quantityStatistics; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "s", function() { return payGgxx; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "n", function() { return searchBannerList; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "p", function() { return userLogin; });
/* unused harmony export loginOut */
/* unused harmony export userInfo */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "o", function() { return register; });
/* unused harmony export acceptCoupon */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return listMemberCoupon; });
/* unused harmony export couponList */
/* unused harmony export selectNotRecive */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return upload; });
/* unused harmony export updateheadimage */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return thanksList; });
/* unused harmony export productHome */
/* unused harmony export bannerList */
/* unused harmony export navList */
/* unused harmony export hotProductList */
/* unused harmony export recommendBrand */
/* unused harmony export newProductList */
/* unused harmony export storeList */
/* unused harmony export applyStore */
/* unused harmony export storeDetail */
/* unused harmony export storeDetail1 */
/* unused harmony export storeHome */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return thank; });
/* unused harmony export categoryAndGoodsList */
/* unused harmony export brandList */
/* unused harmony export goodsList */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "q", function() { return geetest; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__public__ = __webpack_require__(342);


var registerForWeb = function registerForWeb(params) {
  return __WEBPACK_IMPORTED_MODULE_0__public__["a" /* default */].post('/single/home/registerForWeb', params);
};
var getSmsCode = function getSmsCode(params) {
  return __WEBPACK_IMPORTED_MODULE_0__public__["a" /* default */].post('/single/home/sendSmsCodeForWeb', params);
};
var loginForWeb = function loginForWeb(params) {
  return __WEBPACK_IMPORTED_MODULE_0__public__["a" /* default */].post('/single/home/loginForWeb', params);
};
var loginByCodeForWeb = function loginByCodeForWeb(params) {
  return __WEBPACK_IMPORTED_MODULE_0__public__["a" /* default */].post('/single/home/loginByCodeForWeb', params);
};
var userInfoForWeb = function userInfoForWeb(params) {
  return __WEBPACK_IMPORTED_MODULE_0__public__["a" /* default */].post('/single/home/userInfoForWeb', params);
};
var submitUserInfoForWeb = function submitUserInfoForWeb(params) {
  return __WEBPACK_IMPORTED_MODULE_0__public__["a" /* default */].post('/single/home/submitUserInfoForWeb', params);
};
var submitGgxx = function submitGgxx(params) {
  return __WEBPACK_IMPORTED_MODULE_0__public__["a" /* default */].post('/single/home/submitGgxx', params);
};
var searchGgxxPage = function searchGgxxPage(params) {
  return __WEBPACK_IMPORTED_MODULE_0__public__["a" /* default */].post('/single/home/searchGgxxPage', params);
};
var searchGgxxRealCountBatch = function searchGgxxRealCountBatch(params) {
  return __WEBPACK_IMPORTED_MODULE_0__public__["a" /* default */].post('/single/home/searchGgxxRealCountBatch', params);
};
var ggxxDetail = function ggxxDetail(params) {
  return __WEBPACK_IMPORTED_MODULE_0__public__["a" /* default */].post('/single/home/ggxxDetail', params);
};
var searchMyGgxxList = function searchMyGgxxList(params) {
  return __WEBPACK_IMPORTED_MODULE_0__public__["a" /* default */].post('/single/home/searchMyGgxxList', params);
};
var searchMyGgxxPage = function searchMyGgxxPage(params) {
  return __WEBPACK_IMPORTED_MODULE_0__public__["a" /* default */].post('/single/home/searchMyGgxxPage', params);
};

var countMyGgxxNumber = function countMyGgxxNumber(params) {
  return __WEBPACK_IMPORTED_MODULE_0__public__["a" /* default */].post('/single/home/countMyGgxxNumber', params);
};
var visitorList = function visitorList(params) {
  return __WEBPACK_IMPORTED_MODULE_0__public__["a" /* default */].post('/single/home/visitorList', params);
};

var visitorAllList = function visitorAllList(params) {
  return __WEBPACK_IMPORTED_MODULE_0__public__["a" /* default */].post('/single/home/visitorAllList', params);
};
var quantityStatistics = function quantityStatistics(params) {
  return __WEBPACK_IMPORTED_MODULE_0__public__["a" /* default */].post('/single/home/quantityStatistics', params);
};
var payGgxx = function payGgxx(params) {
  return __WEBPACK_IMPORTED_MODULE_0__public__["a" /* default */].post('/single/home/payGgxx', params);
};
var searchBannerList = function searchBannerList(params) {
  return __WEBPACK_IMPORTED_MODULE_0__public__["a" /* default */].post('/single/home/searchBannerList', params);
};
///////////////////////////////////////////////////////////////
// 登陆
var userLogin = function userLogin(params) {
  return __WEBPACK_IMPORTED_MODULE_0__public__["a" /* default */].post('/single/home/login', params);
};
// 退出登陆
var loginOut = function loginOut(params) {
  return __WEBPACK_IMPORTED_MODULE_0__public__["a" /* default */].get('/single/home/logout', params);
};
// 用户信息
var userInfo = function userInfo(params) {
  return __WEBPACK_IMPORTED_MODULE_0__public__["a" /* default */].get('/single/user/currentMember', params);
};
// 注册账号
var register = function register(params) {
  return __WEBPACK_IMPORTED_MODULE_0__public__["a" /* default */].post('/single/home/simpleReg', params);
};

// 获取优惠券
var acceptCoupon = function acceptCoupon(params) {
  return __WEBPACK_IMPORTED_MODULE_0__public__["a" /* default */].post('/single/sms/add', params);
};
// 优惠券列表
var listMemberCoupon = function listMemberCoupon(params) {
  return __WEBPACK_IMPORTED_MODULE_0__public__["a" /* default */].get('/single/sms/listMemberCoupon', params);
};
//  优惠券
var couponList = function couponList(params) {
  return __WEBPACK_IMPORTED_MODULE_0__public__["a" /* default */].get('/single/home/couponList', params);
};
//  可领取的优惠券
var selectNotRecive = function selectNotRecive(params) {
  return __WEBPACK_IMPORTED_MODULE_0__public__["a" /* default */].get('/single/home/selectNotRecive', params);
};

// 上传图片
var upload = function upload(params) {
  return __WEBPACK_IMPORTED_MODULE_0__public__["a" /* default */].get('/single/home/upload', params);
};
// 修改头像
var updateheadimage = function updateheadimage(params) {
  return __WEBPACK_IMPORTED_MODULE_0__public__["a" /* default */].get('/user.editinfo', params);
};
// 捐赠列表
var thanksList = function thanksList(params) {
  return __WEBPACK_IMPORTED_MODULE_0__public__["a" /* default */].get('/member/thanks', params);
};
// 首页接口
var productHome = function productHome(params) {
  return __WEBPACK_IMPORTED_MODULE_0__public__["a" /* default */].get('/pc.getpageconfig', params);
};
// 首页接口
var bannerList = function bannerList(params) {
  return __WEBPACK_IMPORTED_MODULE_0__public__["a" /* default */].get('/single/home/bannerList', params);
};
var navList = function navList(params) {
  return __WEBPACK_IMPORTED_MODULE_0__public__["a" /* default */].get('/single/home/navlist', params);
};
// 查询热销商品
var hotProductList = function hotProductList(params) {
  return __WEBPACK_IMPORTED_MODULE_0__public__["a" /* default */].get('/single/sms/homeRecommendProduct/list', params);
};
// 查询首页推荐品牌
var recommendBrand = function recommendBrand(params) {
  return __WEBPACK_IMPORTED_MODULE_0__public__["a" /* default */].get('/single/sms/homeBrand/list', params);
};
// 查询首页新品
var newProductList = function newProductList(params) {
  return __WEBPACK_IMPORTED_MODULE_0__public__["a" /* default */].get('/single/sms/homeNewProduct/list', params);
};
//  商户列表
var storeList = function storeList(params) {
  return __WEBPACK_IMPORTED_MODULE_0__public__["a" /* default */].get('/single/store/store/list', params);
};

//  商户入驻
var applyStore = function applyStore(params) {
  return __WEBPACK_IMPORTED_MODULE_0__public__["a" /* default */].get('/single/store/applyStore', params);
};
//  商户详情 带用户
var storeDetail = function storeDetail(params) {
  return __WEBPACK_IMPORTED_MODULE_0__public__["a" /* default */].get('/single/store/detail', params);
};
//  商户主页
var storeDetail1 = function storeDetail1(params) {
  return __WEBPACK_IMPORTED_MODULE_0__public__["a" /* default */].get('/single/store/detail1', params);
};
//  商户列表
var storeHome = function storeHome(params) {
  return __WEBPACK_IMPORTED_MODULE_0__public__["a" /* default */].get('/single/store/home', params);
};
// 捐赠板块
var thank = function thank(params) {
  return __WEBPACK_IMPORTED_MODULE_0__public__["a" /* default */].get('/goods/thank', params);
};
// 查询商品分类列表(带商品)
var categoryAndGoodsList = function categoryAndGoodsList(params) {
  return __WEBPACK_IMPORTED_MODULE_0__public__["a" /* default */].get('/single/pms/categoryAndGoodsList/list', params);
};

var brandList = function brandList(params) {
  return __WEBPACK_IMPORTED_MODULE_0__public__["a" /* default */].get('/single/pms/brand/list', params);
};
var goodsList = function goodsList(params) {
  return __WEBPACK_IMPORTED_MODULE_0__public__["a" /* default */].get('/single/pms/goods/list', params);
};

// 极验验证码
var geetest = function geetest(params) {
  return __WEBPACK_IMPORTED_MODULE_0__public__["a" /* default */].get('/member/geetestInit?t=' + new Date().getTime(), params);
};

/***/ }),

/***/ 200:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 320:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// 全站统一的轻量 toast 提示，风格匹配站点棕金主题。
// 替代 element-ui 的 Message，调用方式保持兼容：
//   this.$message('xxx')                     -> info
//   this.$message({ message: 'xxx' })        -> info
//   this.$message({ message:'xxx', type:'success' })
//   this.$message.success('xxx')
//   this.$message.error({ message:'xxx' })
//   this.$message.warning(...)
//   this.$message.info(...)

var CONTAINER_ID = 'phb-message-container';
var STYLE_ID = 'phb-message-style';
var DEFAULT_DURATION = 2600;
var ANIM_MS = 260;

function ensureStyle() {
  if (typeof document === 'undefined') return;
  if (document.getElementById(STYLE_ID)) return;

  var style = document.createElement('style');
  style.id = STYLE_ID;
  style.innerHTML = '\n    #' + CONTAINER_ID + '{\n      position:fixed;\n      top:24px;\n      left:50%;\n      transform:translateX(-50%);\n      z-index:9999;\n      display:flex;\n      flex-direction:column;\n      align-items:center;\n      pointer-events:none;\n    }\n    .phb-msg{\n      pointer-events:auto;\n      min-width:240px;\n      max-width:520px;\n      margin-bottom:12px;\n      padding:12px 22px 12px 16px;\n      display:flex;\n      align-items:center;\n      background:#fff;\n      border-radius:8px;\n      box-shadow:0 8px 24px rgba(125,77,54,0.18);\n      font-family:"Microsoft YaHei","PingFang SC",sans-serif;\n      font-size:14px;\n      color:#3E2D20;\n      border-left:4px solid #A37135;\n      opacity:0;\n      transform:translateY(-12px);\n      transition:opacity ' + ANIM_MS + 'ms ease, transform ' + ANIM_MS + 'ms ease;\n    }\n    .phb-msg.phb-msg-show{\n      opacity:1;\n      transform:translateY(0);\n    }\n    .phb-msg-icon{\n      width:22px;\n      height:22px;\n      flex-shrink:0;\n      margin-right:10px;\n      display:flex;\n      align-items:center;\n      justify-content:center;\n    }\n    .phb-msg-text{\n      line-height:20px;\n      word-break:break-all;\n    }\n    .phb-msg-close{\n      margin-left:14px;\n      width:16px;\n      height:16px;\n      display:flex;\n      align-items:center;\n      justify-content:center;\n      cursor:pointer;\n      color:#B89B70;\n      font-size:14px;\n      line-height:1;\n      flex-shrink:0;\n      border-radius:50%;\n      transition:background .2s;\n    }\n    .phb-msg-close:hover{ background:#F6EFE2; color:#7D4D36; }\n\n    /* \u7C7B\u578B\u4E3B\u9898 */\n    .phb-msg-success{ border-left-color:#7BA77A; }\n    .phb-msg-success .phb-msg-icon{ color:#5E8C5C; }\n    .phb-msg-error{ border-left-color:#C66A55; }\n    .phb-msg-error .phb-msg-icon{ color:#B85A45; }\n    .phb-msg-warning{ border-left-color:#D7A24B; }\n    .phb-msg-warning .phb-msg-icon{ color:#B87E2A; }\n    .phb-msg-info{ border-left-color:#A37135; }\n    .phb-msg-info .phb-msg-icon{ color:#A37135; }\n  ';
  document.head.appendChild(style);
}

function ensureContainer() {
  ensureStyle();
  var el = document.getElementById(CONTAINER_ID);
  if (!el) {
    el = document.createElement('div');
    el.id = CONTAINER_ID;
    document.body.appendChild(el);
  }
  return el;
}

function iconSvg(type) {
  switch (type) {
    case 'success':
      return '<svg viewBox="0 0 22 22" width="22" height="22"><circle cx="11" cy="11" r="10" fill="currentColor" opacity="0.12"/><path d="M6 11.5l3.2 3.2L16 8" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg>';
    case 'error':
      return '<svg viewBox="0 0 22 22" width="22" height="22"><circle cx="11" cy="11" r="10" fill="currentColor" opacity="0.12"/><path d="M7 7l8 8M15 7l-8 8" stroke="currentColor" stroke-width="2" stroke-linecap="round"/></svg>';
    case 'warning':
      return '<svg viewBox="0 0 22 22" width="22" height="22"><circle cx="11" cy="11" r="10" fill="currentColor" opacity="0.12"/><path d="M11 6v6" stroke="currentColor" stroke-width="2" stroke-linecap="round"/><circle cx="11" cy="15.2" r="1.2" fill="currentColor"/></svg>';
    case 'info':
    default:
      return '<svg viewBox="0 0 22 22" width="22" height="22"><circle cx="11" cy="11" r="10" fill="currentColor" opacity="0.12"/><path d="M11 10v6" stroke="currentColor" stroke-width="2" stroke-linecap="round"/><circle cx="11" cy="7.2" r="1.2" fill="currentColor"/></svg>';
  }
}

function show(options) {
  if (typeof document === 'undefined') return {
    close: function close() {}
  };

  var opts = typeof options === 'string' ? { message: options } : options || {};
  var type = opts.type || 'info';
  var message = opts.message || '';
  var duration = typeof opts.duration === 'number' ? opts.duration : DEFAULT_DURATION;
  var showClose = !!opts.showClose;

  var container = ensureContainer();
  var node = document.createElement('div');
  node.className = 'phb-msg phb-msg-' + type;
  node.innerHTML = '<span class="phb-msg-icon">' + iconSvg(type) + '</span>' + '<span class="phb-msg-text"></span>' + (showClose ? '<span class="phb-msg-close">&times;</span>' : '');
  // 通过 textContent 防 XSS
  node.querySelector('.phb-msg-text').textContent = message;
  container.appendChild(node);

  // 强制回流以触发过渡
  // eslint-disable-next-line no-unused-expressions
  node.offsetHeight;
  node.classList.add('phb-msg-show');

  var closed = false;
  var close = function close() {
    if (closed) return;
    closed = true;
    node.classList.remove('phb-msg-show');
    setTimeout(function () {
      if (node.parentNode) node.parentNode.removeChild(node);
    }, ANIM_MS);
  };

  if (duration > 0) {
    setTimeout(close, duration);
  }

  if (showClose) {
    var btn = node.querySelector('.phb-msg-close');
    if (btn) btn.addEventListener('click', close);
  }

  return { close: close };
}

function PhbMessage(options) {
  return show(options);
}

['success', 'warning', 'info', 'error'].forEach(function (t) {
  PhbMessage[t] = function (options) {
    var opts = typeof options === 'string' ? { message: options } : options || {};
    opts.type = t;
    return show(opts);
  };
});

PhbMessage.closeAll = function () {
  var container = document.getElementById(CONTAINER_ID);
  if (!container) return;
  var items = container.querySelectorAll('.phb-msg');
  items.forEach(function (n) {
    n.classList.remove('phb-msg-show');
    setTimeout(function () {
      if (n.parentNode) n.parentNode.removeChild(n);
    }, ANIM_MS);
  });
};

/* harmony default export */ __webpack_exports__["a"] = (PhbMessage);

/***/ }),

/***/ 341:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(722)
}
var Component = __webpack_require__(198)(
  /* script */
  __webpack_require__(376),
  /* template */
  __webpack_require__(742),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 342:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__ = __webpack_require__(216);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise__ = __webpack_require__(385);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_axios__ = __webpack_require__(359);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_qs__ = __webpack_require__(732);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_qs___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_qs__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__utils_storage__ = __webpack_require__(105);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__login__ = __webpack_require__(378);






var instance = __WEBPACK_IMPORTED_MODULE_2_axios___default.a.create({
  transformRequest: [function (data) {
    data = __WEBPACK_IMPORTED_MODULE_3_qs___default.a.stringify(data);
    return data;
  }],
  // localhost
  baseURL: "http://www.hixbao.com.cn:8083/api/",
  // baseURL: "http://localhost:8083/api/",
  timeout: 30000
});
instance.defaults.headers.post["Content-Type"] = "application/x-www-form-urlencoded";
var defaultOpt = { login: true };
var methodsToken = ["user.info", "user.editinfo", "user.changeavatar", "user.logout", "user.addgoodsbrowsing", "user.delgoodsbrowsing", "user.goodsbrowsing", "user.goodscollection", "user.goodscollectionlist", "user.vuesaveusership", "user.saveusership", "user.getshipdetail", "user.setdefship", "user.editship", "user.removeship", "user.getusership", "api/wxpay/user.pay", "user.orderevaluate", "user.getuserdefaultship", "user.issign", "user.sign", "user.mypoint", "user.userpointlog", "user.getbankcardlist", "user.getdefaultbankcard", "user.addbankcard", "user.removebankcard", "user.setdefaultbankcard", "user.getbankcardinfo", "user.editpwd", "user.forgotpwd", "user.recommend", "user.balancelist", "user.sharecode", "user.cash", "user.cashlist", "user.myinvite", "user.activationinvite", "coupon.getcoupon", "coupon.usercoupon", "cart.add", "cart.del", "cart.getlist", "cart.setnums", "cart.getnumber", "order.cancel", "order.del", "order.details", "order.confirm", "order.getlist", "order.create", "submitPreview", "order.getship", "order.getorderlist", "order.getorderstatusnum", "order.aftersaleslist", "order.aftersalesinfo", "order.aftersalesstatus", "order.addaftersales", "order.sendreship", "order.iscomment", "payments.getinfo", "user.getuserpoint", "coupon.getcouponkey", "store.isclerk", "store.storeladinglist", "store.ladinginfo", "store.lading", "store.ladingdel", "distribution_center-api-info", "distribution_center-api-applydistribution", "distribution_center-api-setstore", "distribution_center-api-myorder", "pintuan.pintuanteam", "lottery-api-getLotteryConfig", "lottery-api-lottery", "lottery-api-lotteryLog"];

function baseRequest(options) {
  var token = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__utils_storage__["a" /* getStore */])('token');
  var headers = options.headers || {};

  headers["Accept"] = "application/json";
  headers["Content-Type"] = "application/x-www-form-urlencoded";
  headers["authorization"] = token;
  // headers["storeid"] = 1;
  options.headers = headers;
  if (options.login && !token) {
    //   toLogin();
    //  return Promise.reject({ msg: "未登录", toLogin: true });
  }
  console.log(options);
  var url = options.url.substring(1, options.url.length);
  // 判断token是否存在
  if (methodsToken.indexOf(url) >= 0) {
    if (!token) {
      // this.$router.push({path: '/page/Login/login'})
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__login__["a" /* default */])();
      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a.reject({ msg: "未登录", toLogin: true });
    } else {
      //data.authorization = userToken;
    }
  }

  return instance(options).then(function (res) {
    var data = res.data || {};

    if (res.status !== 200) return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a.reject({ msg: "请求失败", res: res, data: data });

    if ([410000, 410001, 410002, 100].indexOf(data.status) !== -1) {
      // this.$router.push({path: '/page/Login/login'})
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__login__["a" /* default */])();
      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a.reject({ msg: res.data.msg, res: res, data: data, toLogin: true });
    } else if (data.code === 200) {
      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a.resolve(data, res);
    } else {
      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a.resolve(data, res);
    }
  });
}

/**
 * http 请求基础类
 * 参考文档 https://www.kancloud.cn/yunye/axios/234845
 *
 */
var request = ["post", "put", "patch"].reduce(function (request, method) {
  /**
   *
   * @param url string 接口地址
   * @param data object get参数
   * @param options object axios 配置项
   * @returns {AxiosPromise}
   */
  request[method] = function (url, data) {
    var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};

    return baseRequest(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()({ url: url, data: data, method: method }, defaultOpt, options));
  };
  return request;
}, {});

["get", "delete", "head"].forEach(function (method) {
  /**
   *
   * @param url string 接口地址
   * @param params object get参数
   * @param options object axios 配置项
   * @returns {AxiosPromise}
   */
  request[method] = function (url) {
    var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};

    return baseRequest(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()({ url: url, params: params, method: method }, defaultOpt, options));
  };
});

/* harmony default export */ __webpack_exports__["a"] = (request);

/***/ }),

/***/ 376:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_ConsultFloat_vue__ = __webpack_require__(740);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_ConsultFloat_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_ConsultFloat_vue__);
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'app',
  components: { ConsultFloat: __WEBPACK_IMPORTED_MODULE_0__components_ConsultFloat_vue___default.a }
});

/***/ }),

/***/ 377:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'ConsultFloat',
  data: function data() {
    return {
      expanded: false,
      dialogOpen: false
    };
  },
  mounted: function mounted() {
    document.addEventListener('click', this.handleOutside);
  },
  beforeDestroy: function beforeDestroy() {
    document.removeEventListener('click', this.handleOutside);
  },

  methods: {
    toggle: function toggle() {
      this.expanded = !this.expanded;
    },
    openDialog: function openDialog() {
      this.dialogOpen = true;
      this.expanded = false;
    },
    backToTop: function backToTop() {
      var step = Math.max(40, window.scrollY / 20);
      var tick = function tick() {
        if (window.scrollY <= 0) return;
        window.scrollBy(0, -step);
        window.requestAnimationFrame(tick);
      };
      tick();
    },
    submitConsult: function submitConsult() {
      this.dialogOpen = false;
    },
    handleOutside: function handleOutside(e) {
      if (!this.$el.contains(e.target)) {
        this.expanded = false;
      }
    }
  }
});

/***/ }),

/***/ 378:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = toLogin;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__router__ = __webpack_require__(194);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__store__ = __webpack_require__(195);



function toLogin(push, backUrl) {
  var _router$currentRoute = __WEBPACK_IMPORTED_MODULE_0__router__["a" /* default */].currentRoute,
      fullPath = _router$currentRoute.fullPath,
      name = _router$currentRoute.name;


  if (name !== "Login") {
    __WEBPACK_IMPORTED_MODULE_0__router__["a" /* default */].push({ path: "/login" });
  }
}

/***/ }),

/***/ 379:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_element_ui_lib_carousel_item__ = __webpack_require__(324);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_element_ui_lib_carousel_item___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_element_ui_lib_carousel_item__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_element_ui_lib_carousel__ = __webpack_require__(325);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_element_ui_lib_carousel___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_element_ui_lib_carousel__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_element_ui_lib_notification__ = __webpack_require__(330);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_element_ui_lib_notification___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_element_ui_lib_notification__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_element_ui_lib_loading__ = __webpack_require__(329);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_element_ui_lib_loading___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_element_ui_lib_loading__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_element_ui_lib_upload__ = __webpack_require__(336);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_element_ui_lib_upload___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_element_ui_lib_upload__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_element_ui_lib_option__ = __webpack_require__(196);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_element_ui_lib_option___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_element_ui_lib_option__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_element_ui_lib_select__ = __webpack_require__(197);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_element_ui_lib_select___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_element_ui_lib_select__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_element_ui_lib_dialog__ = __webpack_require__(326);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_element_ui_lib_dialog___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_element_ui_lib_dialog__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_element_ui_lib_input__ = __webpack_require__(142);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_element_ui_lib_input___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_element_ui_lib_input__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_element_ui_lib_table_column__ = __webpack_require__(334);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_element_ui_lib_table_column___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_element_ui_lib_table_column__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_element_ui_lib_table__ = __webpack_require__(335);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_element_ui_lib_table___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_element_ui_lib_table__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_element_ui_lib_step__ = __webpack_require__(332);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_element_ui_lib_step___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_element_ui_lib_step__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_element_ui_lib_steps__ = __webpack_require__(333);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_element_ui_lib_steps___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12_element_ui_lib_steps__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_element_ui_lib_autocomplete__ = __webpack_require__(322);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_element_ui_lib_autocomplete___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13_element_ui_lib_autocomplete__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_element_ui_lib_icon__ = __webpack_require__(327);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_element_ui_lib_icon___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14_element_ui_lib_icon__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_element_ui_lib_checkbox__ = __webpack_require__(141);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_element_ui_lib_checkbox___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15_element_ui_lib_checkbox__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_element_ui_lib_pagination__ = __webpack_require__(331);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_element_ui_lib_pagination___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_16_element_ui_lib_pagination__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_element_ui_lib_button__ = __webpack_require__(323);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_element_ui_lib_button___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_17_element_ui_lib_button__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_element_ui_lib_theme_default_index_css__ = __webpack_require__(200);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_element_ui_lib_theme_default_index_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_18_element_ui_lib_theme_default_index_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19_element_ui_lib__ = __webpack_require__(328);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19_element_ui_lib___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_19_element_ui_lib__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20_vue__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__App__ = __webpack_require__(341);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__App___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_21__App__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__router__ = __webpack_require__(194);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__store___ = __webpack_require__(195);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24_vue_lazyload__ = __webpack_require__(340);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25_vue_infinite_scroll__ = __webpack_require__(339);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25_vue_infinite_scroll___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_25_vue_infinite_scroll__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26_vue_cookie__ = __webpack_require__(338);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26_vue_cookie___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_26_vue_cookie__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27__api__ = __webpack_require__(199);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28__utils_storage__ = __webpack_require__(105);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_29_vue_content_placeholders__ = __webpack_require__(337);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_30__common_phbMessage__ = __webpack_require__(320);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_31_echarts__ = __webpack_require__(321);
































//import echarts from 'echarts'


__WEBPACK_IMPORTED_MODULE_20_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_19_element_ui_lib___default.a);
__WEBPACK_IMPORTED_MODULE_20_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_29_vue_content_placeholders__["default"]);
__WEBPACK_IMPORTED_MODULE_20_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_17_element_ui_lib_button___default.a);
__WEBPACK_IMPORTED_MODULE_20_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_16_element_ui_lib_pagination___default.a);
__WEBPACK_IMPORTED_MODULE_20_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_15_element_ui_lib_checkbox___default.a);
__WEBPACK_IMPORTED_MODULE_20_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_14_element_ui_lib_icon___default.a);
__WEBPACK_IMPORTED_MODULE_20_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_13_element_ui_lib_autocomplete___default.a);
__WEBPACK_IMPORTED_MODULE_20_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_12_element_ui_lib_steps___default.a);
__WEBPACK_IMPORTED_MODULE_20_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_11_element_ui_lib_step___default.a);
__WEBPACK_IMPORTED_MODULE_20_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_10_element_ui_lib_table___default.a);
__WEBPACK_IMPORTED_MODULE_20_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_9_element_ui_lib_table_column___default.a);
__WEBPACK_IMPORTED_MODULE_20_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_8_element_ui_lib_input___default.a);
__WEBPACK_IMPORTED_MODULE_20_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_7_element_ui_lib_dialog___default.a);
__WEBPACK_IMPORTED_MODULE_20_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_6_element_ui_lib_select___default.a);
__WEBPACK_IMPORTED_MODULE_20_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_5_element_ui_lib_option___default.a);
__WEBPACK_IMPORTED_MODULE_20_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_4_element_ui_lib_upload___default.a);
__WEBPACK_IMPORTED_MODULE_20_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_3_element_ui_lib_loading___default.a.directive);
__WEBPACK_IMPORTED_MODULE_20_vue__["default"].prototype.$loading = __WEBPACK_IMPORTED_MODULE_3_element_ui_lib_loading___default.a.service;
__WEBPACK_IMPORTED_MODULE_20_vue__["default"].prototype.$notify = __WEBPACK_IMPORTED_MODULE_2_element_ui_lib_notification___default.a;
__WEBPACK_IMPORTED_MODULE_20_vue__["default"].prototype.$message = __WEBPACK_IMPORTED_MODULE_30__common_phbMessage__["a" /* default */];
__WEBPACK_IMPORTED_MODULE_20_vue__["default"].prototype.$echarts = __WEBPACK_IMPORTED_MODULE_31_echarts__;
__WEBPACK_IMPORTED_MODULE_20_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_25_vue_infinite_scroll___default.a);
__WEBPACK_IMPORTED_MODULE_20_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_26_vue_cookie___default.a);
__WEBPACK_IMPORTED_MODULE_20_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_1_element_ui_lib_carousel___default.a);
__WEBPACK_IMPORTED_MODULE_20_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_0_element_ui_lib_carousel_item___default.a);
__WEBPACK_IMPORTED_MODULE_20_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_24_vue_lazyload__["a" /* default */], {
  // preLoad: 1.3,
  // error: 'dist/error.png',
  loading: '/static/images/load.gif'
  // attempt: 1
});
__WEBPACK_IMPORTED_MODULE_20_vue__["default"].config.productionTip = false;
var whiteList = ['/home', '/goods', '/login', '/register', '/goodsDetails', '/thanks', '/search', '/refreshsearch', '/refreshgoods']; // 不需要登陆的页面


/* eslint-disable no-new */
new __WEBPACK_IMPORTED_MODULE_20_vue__["default"]({
  el: '#app',
  store: __WEBPACK_IMPORTED_MODULE_23__store___["a" /* default */],
  router: __WEBPACK_IMPORTED_MODULE_22__router__["a" /* default */],
  render: function render(h) {
    return h(__WEBPACK_IMPORTED_MODULE_21__App___default.a);
  }
});

/***/ }),

/***/ 380:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({});

/***/ }),

/***/ 381:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return INIT_BUYCART; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return ADD_CART; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return GET_USERINFO; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return RECORD_USERINFO; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return ADD_ANIMATION; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return SHOW_CART; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return REDUCE_CART; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return EDIT_CART; });
var INIT_BUYCART = 'INIT_BUYCART';
var ADD_CART = 'ADD_CART';
var GET_USERINFO = 'GET_USERINFO';
var RECORD_USERINFO = 'RECORD_USERINFO';
var ADD_ANIMATION = 'ADD_ANIMATION';
var SHOW_CART = 'SHOW_CART';
var REDUCE_CART = 'REDUCE_CART';
var EDIT_CART = 'EDIT_CART';

/***/ }),

/***/ 382:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__(386);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__(344);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__mutation_types__ = __webpack_require__(381);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utils_storage__ = __webpack_require__(105);



var _INIT_BUYCART$ADD_CAR;



/* harmony default export */ __webpack_exports__["a"] = (_INIT_BUYCART$ADD_CAR = {}, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_INIT_BUYCART$ADD_CAR, __WEBPACK_IMPORTED_MODULE_2__mutation_types__["a" /* INIT_BUYCART */], function (state) {
  var initCart = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__utils_storage__["a" /* getStore */])('buyCart');
  if (initCart) {
    state.cartList = JSON.parse(initCart);
  }
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_INIT_BUYCART$ADD_CAR, __WEBPACK_IMPORTED_MODULE_2__mutation_types__["b" /* ADD_CART */], function (state, _ref) {
  var productId = _ref.productId,
      salePrice = _ref.salePrice,
      productName = _ref.productName,
      productImg = _ref.productImg,
      _ref$productNum = _ref.productNum,
      productNum = _ref$productNum === undefined ? 1 : _ref$productNum;

  var cart = state.cartList; // 购物车
  var falg = true;
  var goods = {
    productId: productId,
    salePrice: salePrice,
    productName: productName,
    productImg: productImg
  };
  if (cart.length) {
    // 有内容
    cart.forEach(function (item) {
      if (item.productId === productId) {
        if (item.productNum >= 0) {
          falg = false;
          item.productNum += productNum;
        }
      }
    });
  }
  if (!cart.length || falg) {
    goods.productNum = productNum;
    goods.checked = '1';
    cart.push(goods);
  }
  state.cartList = cart;
  // 存入localStorage
  __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__utils_storage__["b" /* setStore */])('buyCart', cart);
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_INIT_BUYCART$ADD_CAR, __WEBPACK_IMPORTED_MODULE_2__mutation_types__["c" /* ADD_ANIMATION */], function (state, _ref2) {
  var moveShow = _ref2.moveShow,
      elLeft = _ref2.elLeft,
      elTop = _ref2.elTop,
      img = _ref2.img,
      cartPositionT = _ref2.cartPositionT,
      cartPositionL = _ref2.cartPositionL,
      receiveInCart = _ref2.receiveInCart;

  state.showMoveImg = moveShow;
  if (elLeft) {
    state.elLeft = elLeft;
    state.elTop = elTop;
  }
  state.moveImgUrl = img;
  state.receiveInCart = receiveInCart;
  if (cartPositionT) {
    state.cartPositionT = cartPositionT;
    state.cartPositionL = cartPositionL;
  }
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_INIT_BUYCART$ADD_CAR, __WEBPACK_IMPORTED_MODULE_2__mutation_types__["d" /* SHOW_CART */], function (state, _ref3) {
  var showCart = _ref3.showCart;

  // let timer = null
  state.showCart = showCart;
  // clearTimeout(timer)
  // if (showCart) {
  //   timer = setTimeout(() => {
  //     state.showCart = false
  //   }, 5000)
  // }
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_INIT_BUYCART$ADD_CAR, __WEBPACK_IMPORTED_MODULE_2__mutation_types__["e" /* REDUCE_CART */], function (state, _ref4) {
  var productId = _ref4.productId;

  var cart = state.cartList;
  cart.forEach(function (item, i) {
    if (item.productId === productId) {
      if (item.productNum > 1) {
        item.productNum--;
      } else {
        cart.splice(i, 1);
      }
    }
  });
  state.cartList = cart;
  // 存入localStorage
  __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__utils_storage__["b" /* setStore */])('buyCart', state.cartList);
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_INIT_BUYCART$ADD_CAR, __WEBPACK_IMPORTED_MODULE_2__mutation_types__["f" /* EDIT_CART */], function (state, _ref5) {
  var productId = _ref5.productId,
      productNum = _ref5.productNum,
      checked = _ref5.checked;

  var cart = state.cartList;
  if (productNum) {
    cart.forEach(function (item, i) {
      if (item.productId === productId) {
        item.productNum = productNum;
        item.checked = checked;
      }
    });
  } else if (productId) {
    cart.forEach(function (item, i) {
      if (item.productId === productId) {
        cart.splice(i, 1);
      }
    });
  } else {
    cart.forEach(function (item) {
      item.checked = checked ? '1' : '0';
    });
  }
  state.cartList = cart;
  // 存入localStorage
  __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__utils_storage__["b" /* setStore */])('buyCart', state.cartList);
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_INIT_BUYCART$ADD_CAR, __WEBPACK_IMPORTED_MODULE_2__mutation_types__["g" /* RECORD_USERINFO */], function (state, info) {
  state.userInfo = info;
  state.login = true;
  __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__utils_storage__["b" /* setStore */])('userInfo', info);
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_INIT_BUYCART$ADD_CAR, __WEBPACK_IMPORTED_MODULE_2__mutation_types__["h" /* GET_USERINFO */], function (state, info) {
  if (state.userInfo && state.userInfo.username !== info.username) {
    return;
  }
  if (!state.login) {
    return;
  }
  if (!info.message) {
    state.userInfo = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, info);
  } else {
    state.userInfo = null;
  }
}), _INIT_BUYCART$ADD_CAR);

/***/ }),

/***/ 720:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 721:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 722:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 740:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(721)
}
var Component = __webpack_require__(198)(
  /* script */
  __webpack_require__(377),
  /* template */
  __webpack_require__(741),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-eee848da",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 741:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "cf-root"
  }, [_c('div', {
    staticClass: "consult-float"
  }, [_c('button', {
    staticClass: "cf-main",
    attrs: {
      "type": "button",
      "aria-label": "联系咨询"
    },
    on: {
      "click": _vm.toggle
    }
  }, [_c('svg', {
    attrs: {
      "viewBox": "0 0 1024 1024",
      "width": "40",
      "height": "40"
    }
  }, [_c('path', {
    attrs: {
      "fill": "currentColor",
      "d": "M512 96C264.6 96 64 268.6 64 481.5c0 122.4 66.3 231.2 169.9 301.6L208 928l143.4-86.4c50.7 14.1 105 21.9 160.6 21.9 247.4 0 448-172.6 448-385.5S759.4 96 512 96zm-160 416a48 48 0 1 1 0-96 48 48 0 0 1 0 96zm160 0a48 48 0 1 1 0-96 48 48 0 0 1 0 96zm160 0a48 48 0 1 1 0-96 48 48 0 0 1 0 96z"
    }
  })]), _vm._v(" "), _c('span', {
    staticClass: "cf-main-text"
  }, [_vm._v("咨询")]), _vm._v(" "), _c('span', {
    staticClass: "cf-pulse"
  }), _vm._v(" "), _c('span', {
    staticClass: "cf-pulse cf-pulse-delay"
  })]), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "cf-roll"
    }
  }, [_c('ul', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.expanded),
      expression: "expanded"
    }],
    staticClass: "cf-actions"
  }, [_c('li', {
    staticClass: "cf-action",
    on: {
      "click": _vm.openDialog
    }
  }, [_c('svg', {
    attrs: {
      "viewBox": "0 0 1024 1024",
      "width": "28",
      "height": "28"
    }
  }, [_c('path', {
    attrs: {
      "fill": "currentColor",
      "d": "M512 96C264.6 96 64 268.6 64 481.5c0 122.4 66.3 231.2 169.9 301.6L208 928l143.4-86.4c50.7 14.1 105 21.9 160.6 21.9 247.4 0 448-172.6 448-385.5S759.4 96 512 96zm-89.6 432.5l-112-112 39.6-39.6 72.4 72.4 184.4-184.4 39.6 39.6-224 224z"
    }
  })]), _vm._v(" "), _c('span', {
    staticClass: "cf-label"
  }, [_vm._v("在线咨询")])]), _vm._v(" "), _c('li', {
    staticClass: "cf-action"
  }, [_c('svg', {
    attrs: {
      "viewBox": "0 0 1024 1024",
      "width": "28",
      "height": "28"
    }
  }, [_c('path', {
    attrs: {
      "fill": "currentColor",
      "d": "M758.2 624.6c-15.6-7.9-91.9-45.3-106.1-50.5-14.2-5.2-24.6-7.8-35 7.8-10.4 15.6-40.1 50.5-49.2 60.9-9.1 10.4-18.1 11.7-33.7 3.9-15.6-7.8-65.7-24.2-125.2-77.2-46.3-41.3-77.5-92.3-86.6-107.9-9.1-15.6-1-24.1 6.8-31.9 7-7 15.6-18.2 23.4-27.3 7.8-9.1 10.4-15.6 15.6-26 5.2-10.4 2.6-19.5-1.3-27.3-3.9-7.8-35-84.3-47.9-115.4-12.6-30.3-25.5-26.2-35-26.7-9.1-.5-19.5-.6-29.9-.6-10.4 0-27.3 3.9-41.6 19.5-14.3 15.6-54.6 53.4-54.6 130s55.9 150.6 63.7 161c7.8 10.4 110 168 266.5 235.5 37.2 16.1 66.3 25.7 88.9 32.9 37.3 11.9 71.3 10.2 98.2 6.2 30-4.5 91.9-37.5 104.8-73.7 12.9-36.2 12.9-67.3 9.1-73.7-3.9-6.4-14.3-10.3-29.9-18.2z"
    }
  }), _c('path', {
    attrs: {
      "fill": "currentColor",
      "d": "M512 64C264.6 64 64 264.6 64 512c0 88.5 25.7 170.8 70 240.2L96 928l180.1-37.5C347.4 936.7 427.3 960 512 960c247.4 0 448-200.6 448-448S759.4 64 512 64zm0 819.2c-76.8 0-148.5-21.3-209.7-58.3l-15-9-115.7 24.1 24.7-112.7-9.8-15.5C148.7 651.1 124.8 583.5 124.8 512 124.8 298.5 298.5 124.8 512 124.8S899.2 298.5 899.2 512 725.5 883.2 512 883.2z"
    }
  })]), _vm._v(" "), _c('span', {
    staticClass: "cf-label"
  }, [_vm._v("微信咨询")]), _vm._v(" "), _c('div', {
    staticClass: "cf-popover cf-popover-wechat"
  }, [_c('div', {
    staticClass: "cf-pop-title"
  }, [_vm._v("扫码添加客服微信")]), _vm._v(" "), _c('div', {
    staticClass: "cf-qrcode"
  }, [_c('div', {
    staticClass: "cf-qrcode-placeholder"
  }, [_c('svg', {
    attrs: {
      "viewBox": "0 0 100 100",
      "width": "120",
      "height": "120"
    }
  }, [_c('rect', {
    attrs: {
      "width": "100",
      "height": "100",
      "fill": "#fff"
    }
  }), _c('g', {
    attrs: {
      "fill": "#3E2D20"
    }
  }, [_c('rect', {
    attrs: {
      "x": "8",
      "y": "8",
      "width": "22",
      "height": "22"
    }
  }), _c('rect', {
    attrs: {
      "x": "14",
      "y": "14",
      "width": "10",
      "height": "10",
      "fill": "#fff"
    }
  }), _c('rect', {
    attrs: {
      "x": "70",
      "y": "8",
      "width": "22",
      "height": "22"
    }
  }), _c('rect', {
    attrs: {
      "x": "76",
      "y": "14",
      "width": "10",
      "height": "10",
      "fill": "#fff"
    }
  }), _c('rect', {
    attrs: {
      "x": "8",
      "y": "70",
      "width": "22",
      "height": "22"
    }
  }), _c('rect', {
    attrs: {
      "x": "14",
      "y": "76",
      "width": "10",
      "height": "10",
      "fill": "#fff"
    }
  }), _c('rect', {
    attrs: {
      "x": "38",
      "y": "10",
      "width": "6",
      "height": "6"
    }
  }), _c('rect', {
    attrs: {
      "x": "50",
      "y": "14",
      "width": "6",
      "height": "6"
    }
  }), _c('rect', {
    attrs: {
      "x": "60",
      "y": "10",
      "width": "4",
      "height": "4"
    }
  }), _c('rect', {
    attrs: {
      "x": "40",
      "y": "24",
      "width": "8",
      "height": "6"
    }
  }), _c('rect', {
    attrs: {
      "x": "56",
      "y": "24",
      "width": "6",
      "height": "6"
    }
  }), _c('rect', {
    attrs: {
      "x": "10",
      "y": "40",
      "width": "6",
      "height": "6"
    }
  }), _c('rect', {
    attrs: {
      "x": "22",
      "y": "38",
      "width": "8",
      "height": "8"
    }
  }), _c('rect', {
    attrs: {
      "x": "36",
      "y": "40",
      "width": "6",
      "height": "6"
    }
  }), _c('rect', {
    attrs: {
      "x": "48",
      "y": "38",
      "width": "10",
      "height": "10"
    }
  }), _c('rect', {
    attrs: {
      "x": "64",
      "y": "40",
      "width": "6",
      "height": "6"
    }
  }), _c('rect', {
    attrs: {
      "x": "76",
      "y": "40",
      "width": "8",
      "height": "6"
    }
  }), _c('rect', {
    attrs: {
      "x": "86",
      "y": "48",
      "width": "6",
      "height": "6"
    }
  }), _c('rect', {
    attrs: {
      "x": "14",
      "y": "54",
      "width": "6",
      "height": "6"
    }
  }), _c('rect', {
    attrs: {
      "x": "28",
      "y": "52",
      "width": "8",
      "height": "8"
    }
  }), _c('rect', {
    attrs: {
      "x": "42",
      "y": "56",
      "width": "6",
      "height": "6"
    }
  }), _c('rect', {
    attrs: {
      "x": "56",
      "y": "54",
      "width": "6",
      "height": "6"
    }
  }), _c('rect', {
    attrs: {
      "x": "68",
      "y": "52",
      "width": "10",
      "height": "10"
    }
  }), _c('rect', {
    attrs: {
      "x": "82",
      "y": "60",
      "width": "6",
      "height": "6"
    }
  }), _c('rect', {
    attrs: {
      "x": "38",
      "y": "68",
      "width": "8",
      "height": "6"
    }
  }), _c('rect', {
    attrs: {
      "x": "50",
      "y": "68",
      "width": "6",
      "height": "6"
    }
  }), _c('rect', {
    attrs: {
      "x": "60",
      "y": "68",
      "width": "6",
      "height": "6"
    }
  }), _c('rect', {
    attrs: {
      "x": "74",
      "y": "74",
      "width": "6",
      "height": "6"
    }
  }), _c('rect', {
    attrs: {
      "x": "86",
      "y": "74",
      "width": "6",
      "height": "6"
    }
  }), _c('rect', {
    attrs: {
      "x": "40",
      "y": "82",
      "width": "6",
      "height": "6"
    }
  }), _c('rect', {
    attrs: {
      "x": "52",
      "y": "80",
      "width": "10",
      "height": "10"
    }
  }), _c('rect', {
    attrs: {
      "x": "68",
      "y": "86",
      "width": "6",
      "height": "6"
    }
  })])])])]), _vm._v(" "), _c('div', {
    staticClass: "cf-pop-desc"
  }, [_vm._v("微信号：qfyd2013")])])]), _vm._v(" "), _c('li', {
    staticClass: "cf-action"
  }, [_c('svg', {
    attrs: {
      "viewBox": "0 0 1024 1024",
      "width": "28",
      "height": "28"
    }
  }, [_c('path', {
    attrs: {
      "fill": "currentColor",
      "d": "M885.6 230.2L744.3 88.9c-25-25-65.5-25-90.5 0L582.5 160c-25 25-25 65.5 0 90.5l53 53c-39.7 90.1-115.9 166.2-205.9 205.9l-53-53c-25-25-65.5-25-90.5 0L215 527.6c-25 25-25 65.5 0 90.5l141.3 141.3c25 25 65.5 25 90.5 0 251.4-117.5 451-317.1 568.5-568.5 25-25 25-65.5 0-90.5z"
    }
  })]), _vm._v(" "), _c('span', {
    staticClass: "cf-label"
  }, [_vm._v("电话咨询")]), _vm._v(" "), _c('div', {
    staticClass: "cf-popover cf-popover-phone"
  }, [_c('div', {
    staticClass: "cf-pop-title"
  }, [_vm._v("客服热线")]), _vm._v(" "), _c('div', {
    staticClass: "cf-phone-num"
  }, [_vm._v("138 1716 6429")]), _vm._v(" "), _c('div', {
    staticClass: "cf-pop-desc"
  }, [_vm._v("工作日 9:00 - 18:00")])])]), _vm._v(" "), _c('li', {
    staticClass: "cf-action cf-top",
    on: {
      "click": _vm.backToTop
    }
  }, [_c('svg', {
    attrs: {
      "viewBox": "0 0 1024 1024",
      "width": "28",
      "height": "28"
    }
  }, [_c('path', {
    attrs: {
      "fill": "currentColor",
      "d": "M512 192L192 512h192v320h256V512h192z"
    }
  })]), _vm._v(" "), _c('span', {
    staticClass: "cf-label"
  }, [_vm._v("回到顶部")])])])])], 1), _vm._v(" "), (_vm.dialogOpen) ? _c('div', {
    staticClass: "cf-dialog-mask",
    on: {
      "click": function($event) {
        if ($event.target !== $event.currentTarget) { return null; }
        _vm.dialogOpen = false
      }
    }
  }, [_c('div', {
    staticClass: "cf-dialog"
  }, [_c('div', {
    staticClass: "cf-dialog-head"
  }, [_c('div', {
    staticClass: "cf-dialog-title"
  }, [_c('svg', {
    attrs: {
      "viewBox": "0 0 1024 1024",
      "width": "20",
      "height": "20"
    }
  }, [_c('path', {
    attrs: {
      "fill": "currentColor",
      "d": "M512 96C264.6 96 64 268.6 64 481.5c0 122.4 66.3 231.2 169.9 301.6L208 928l143.4-86.4c50.7 14.1 105 21.9 160.6 21.9 247.4 0 448-172.6 448-385.5S759.4 96 512 96z"
    }
  })]), _vm._v(" "), _c('span', [_vm._v("在线咨询")])]), _vm._v(" "), _c('button', {
    staticClass: "cf-dialog-close",
    attrs: {
      "type": "button",
      "aria-label": "关闭"
    },
    on: {
      "click": function($event) {
        _vm.dialogOpen = false
      }
    }
  }, [_c('svg', {
    attrs: {
      "viewBox": "0 0 1024 1024",
      "width": "16",
      "height": "16"
    }
  }, [_c('path', {
    attrs: {
      "fill": "currentColor",
      "d": "M941.6 184.2L839.8 82.4 512 410.2 184.2 82.4 82.4 184.2 410.2 512 82.4 839.8l101.8 101.8L512 613.8l327.8 327.8 101.8-101.8L613.8 512z"
    }
  })])])]), _vm._v(" "), _vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "cf-dialog-foot"
  }, [_c('button', {
    staticClass: "cf-btn cf-btn-ghost",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.dialogOpen = false
      }
    }
  }, [_vm._v("稍后再说")]), _vm._v(" "), _c('button', {
    staticClass: "cf-btn cf-btn-primary",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.submitConsult
    }
  }, [_vm._v("提交咨询")])])])]) : _vm._e()])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "cf-dialog-body"
  }, [_c('div', {
    staticClass: "cf-dialog-intro"
  }, [_vm._v("\n          您好，欢迎咨询尚博慧。请留下您的联系方式，我们将尽快与您取得联系。\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "cf-form-row"
  }, [_c('label', [_vm._v("称呼")]), _vm._v(" "), _c('input', {
    attrs: {
      "type": "text",
      "placeholder": "请输入您的称呼"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "cf-form-row"
  }, [_c('label', [_vm._v("手机号")]), _vm._v(" "), _c('input', {
    attrs: {
      "type": "text",
      "placeholder": "请输入联系电话"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "cf-form-row"
  }, [_c('label', [_vm._v("咨询内容")]), _vm._v(" "), _c('textarea', {
    attrs: {
      "rows": "4",
      "placeholder": "请简要描述您想咨询的问题"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "cf-dialog-tip"
  }, [_c('span', {
    staticClass: "cf-dot"
  }), _vm._v("\n          提交后客服会在 1 个工作日内与您联系\n        ")])])
}]}

/***/ }),

/***/ 742:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "app"
    }
  }, [_c('router-view', {
    staticClass: "main"
  }), _vm._v(" "), _c('consult-float')], 1)
},staticRenderFns: []}

/***/ }),

/***/ 778:
/***/ (function(module, exports) {

/* (ignored) */

/***/ })

},[379]);


// WEBPACK FOOTER //
// static/js/app.a9b160a6ad7d72b753ed.js